import React from "react";
import PropTypes from "prop-types";
import { getCopy, getDiscountPercent } from "../helper";
import { PriceLabel } from "./styled";

const COPY_ID_PREFIX = "OfferAccountPrice";

export default function PriceLabelTag({
  intl,
  priceWithoutDiscount,
  price,
  variant,
}) {
  if (!priceWithoutDiscount || !price) {
    return null;
  }
  return (
    <PriceLabel variant={variant}>
      {getDiscountPercent(priceWithoutDiscount, price)}%{" "}
      {getCopy(intl, `${COPY_ID_PREFIX}.off`)}
    </PriceLabel>
  );
}

PriceLabelTag.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  priceWithoutDiscount: PropTypes.number.isRequired,
  price: PropTypes.number.isRequired,
  variant: PropTypes.oneOf(["red", "yellow"]),
};
